import * as React from "react";
import { useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { agenda } from "../data/agenda";
import { NavBarTest } from "../../../components/NavBarTest";
import { Footer } from '../../../components/index';
import Paper from "@mui/material/Paper";

function TabPanel(props) {
   const { children, value, index, ...other } = props;

   return (
      <div
         role="tabpanel"
         hidden={value !== index}
         id={`simple-tabpanel-${index}`}
         aria-labelledby={`simple-tab-${index}`}
         {...other}
      >
         {value === index && (
            <Box sx={{ p: 4, backgroundColor: "#212529" }}>
               <Typography>{children}</Typography>
            </Box>
         )}
      </div>
   );
}

TabPanel.propTypes = {
   children: PropTypes.node,
   index: PropTypes.number.isRequired,
   value: PropTypes.number.isRequired,
};




export const Agenda = () => {
   document.title = "Venture Summit Digital Connect | Agenda";

   useEffect(() => {
      var bz = document.createElement("script");
      bz.type = "text/javascript";
      bz.async = true;
      bz.src = "https://organizer.bizzabo.com/widgets/agenda/agenda.js";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(bz, s);
   });

   return (
      <div style={{ backgroundColor: "#212529" }}>
         <NavBarTest />
         <h1
            style={{
               textAlign: "center",
               paddingTop: "15vh",
               paddingBottom: "5vh",
               marginBottom: "5vh",
               fontWeight: "900",
               color: "white",
               backgroundColor: "#212529",
            }}
         >
            AGENDA
         </h1>
         {/* <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            centered
            TabIndicatorProps={{ style: { background: "#3F6BFD" } }}
            style={{ backgroundColor: "#212529" }}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="ALL" {...a11yProps(0)} />
            <Tab label="DAY 1" {...a11yProps(1)} />
            <Tab label="DAY 2" {...a11yProps(2)} />
            <Tab label="DAY 3" {...a11yProps(3)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
       {agenda.forEach(item => {
    item.panels.map((panel, i) =><div
    key={i}
    style={{
      backgroundColor: "white",
      height: "15vh",
      width: "75%",
      margin: "auto",
      borderRadius: "10px",
      marginTop: "2.55vh",
    }}
  ></div>)
  })}
        </TabPanel>
        <TabPanel value={value} index={1}>
        {agenda[0].panels.map((item, i) => (
            <div
              key={i}
              style={{
                backgroundColor: "white",
                height: "15vh",
                width: "75%",
                margin: "auto",
                borderRadius: "10px",
                marginTop: "2.55vh",
              }}
            ></div>
          ))}
        </TabPanel>
        <TabPanel value={value} index={2}>
        {agenda[1].panels.map((item, i) => (
            <div
              key={i}
              style={{
                backgroundColor: "white",
                height: "15vh",
                width: "75%",
                margin: "auto",
                borderRadius: "10px",
                marginTop: "2.55vh",
              }}
            ></div>
          ))}
        </TabPanel>
        <TabPanel value={value} index={3}>
        {agenda[2].panels.map((item, i) => (
            <div
              key={i}
              style={{
                backgroundColor: "white",
                height: "15vh",
                width: "75%",
                margin: "auto",
                borderRadius: "10px",
                marginTop: "2.55vh",
              }}
            ></div>
          ))}
        </TabPanel>
      </Box> */}
         <Paper elevation={3} sx={{ m: window.innerWidth < 769 ? 0 : 5, p: window.innerWidth < 769 ? 0 : 5 }}>
            <div name="bizzabo-web-agenda" data-unique-name="378401" data-internal-website-base-url="https://events.bizzabo.com/378401"></div>
            <a
               rel='noreferrer'
               className="bizzabo-link-class"
               style={{
                  textAlign: "right",
                  paddingRight: "17px",
                  textDecoration: "none",
                  width: "100%",
                  display: "inline-block",
                  marginTop: "5px",
                  boxSizing: "border-box",
               }}
               href="https://www.bizzabo.com?utm_source=tickets_widget&utm_medium=powered_by&utm_campaign=tickets_widget"
               target="_blank"
            >
               Powered by Bizzabo
            </a>
         </Paper>
         <Footer />
      </div>
   );
};
